export default "__VITE_ASSET__bff84075__"